export const bodyEl = document.querySelector("body")!;
export const navEl = document.querySelector("nav")!;
export const photoLinkEl = document.createElement("a");
photoLinkEl.innerText = "Photo";
